// ADDED
import { useState } from 'react';
import { timeEntriesService } from '../services/timeEntriesService';

export const useTimeEntries = () => {
  const [isProcessingTemplate, setIsProcessingTemplate] = useState(false);

  const getDatesInRange = (startDate, endDate) => {
    const dates = [];
    let current = new Date(startDate);
    const last = new Date(endDate);

    // Safety check for invalid dates
    if (isNaN(current.getTime()) || isNaN(last.getTime())) return [];

    while (current <= last) {
      dates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  // MODIFIED
  const prepareTemplateData = async (payrollPeriodId, classificationId) => {
    setIsProcessingTemplate(true);
    try {
      const [period, employees] = await Promise.all([
        timeEntriesService.getPayrollPeriodById(payrollPeriodId),
        timeEntriesService.getEmployees()
      ]);

      const filteredEmployees = employees.filter(emp => {
        // ADDED: Check if we should show all classifications
        const isAllClassifications = !classificationId || classificationId === "0" || classificationId === 0 || classificationId === null;

        // MODIFIED: Match classification only if a specific one is requested
        const classificationMatches = isAllClassifications ||
          emp.employeeInformation?.classificationId?.toString() === classificationId?.toString();

        // CONSTRAINTS: Always ensure the employee is Active
        const isActive = emp.employeeStatuses?.status === "Active";

        return classificationMatches && isActive;
      });

      const dateRange = getDatesInRange(period.dateFrom, period.dateTo);
      const rows = [];

      // Sort employees by Name for better UX in Excel
      filteredEmployees.sort((a, b) => (a.fullName || "").localeCompare(b.fullName || ""));

      filteredEmployees.forEach(emp => {
        dateRange.forEach(date => {
          rows.push({
            employeeId: emp.employeeId,
            fullName: emp.fullName,
            date: date.toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }),
          });
        });
      });

      return rows;
    } catch (error) {
      console.error("❌ Failed to prepare template data", error);
      return [];
    } finally {
      setIsProcessingTemplate(false);
    }
  };

  return { prepareTemplateData, isProcessingTemplate };
};